import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

export const RedirectToPublicSubmission = () => {
  const { submissionId, accountId, matchesId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    void navigate(
      `/account/${accountId}/submission/${submissionId}/engagement${matchesId ? `/${matchesId}` : ''}`,
      { replace: true }
    );
  }, [navigate, submissionId, accountId, matchesId]);

  return null;
};
